(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 760px)');
    var header = document.querySelector('.ve-header');
    var btn = document.querySelector('[data-ve-burger]');
    var nav = document.getElementById('ve-nav');
    if (!header || !btn || !nav) return;
    Array.prototype.forEach.call(nav.children, function (el, i) { el.style.setProperty('--n', i); });
    function sync() {
      /* on phones the submenu is always shown inside the sheet */
      nav.querySelectorAll('.ve-dd').forEach(function (d) { if (mq.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); });
    }
    function setOpen(on) {
      header.classList.toggle('is-open', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    sync();
    btn.addEventListener('click', function () { setOpen(!header.classList.contains('is-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('click', function (e) {
      if (header.classList.contains('is-open') && !header.querySelector('.ve-header__inner').contains(e.target) && !nav.contains(e.target)) setOpen(false);
    });
    nav.addEventListener('click', function (e) { if (e.target.closest('[data-ve-search-open]')) setOpen(false); });
    mq.addEventListener('change', function () { setOpen(false); sync(); });
  })();
  document.addEventListener('click', function (e) {
    if (window.matchMedia('(max-width: 760px)').matches) return;
    document.querySelectorAll('.ve-dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !window.matchMedia('(max-width: 760px)').matches) {
      document.querySelectorAll('.ve-dd[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-ve-buybox]').forEach(function (box) {
    var price = box.querySelector('[data-ve-price]');
    var cmp = box.querySelector('[data-ve-compare]');
    var save = box.querySelector('[data-ve-save]');
    box.querySelectorAll('.ve-packs input[type=radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (price) price.textContent = r.dataset.price;
        if (cmp) { cmp.textContent = r.dataset.compare; cmp.hidden = !r.dataset.compare; }
        if (save) { save.textContent = r.dataset.save; save.hidden = !r.dataset.save; }
      });
    });
    var q = box.querySelector('[data-ve-qty]');
    if (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qty));
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-category-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ve-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[k].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); select(i, false); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(j, true); }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ve-hero]').forEach(function (root) {
    var track = root.querySelector('.ve-hero__track');
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    var dots = root.querySelectorAll('[data-dot]');
    var pauseBtn = root.querySelector('[data-pause]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, timer = null, userPaused = reduce, hold = false, moving = 0;

    function step() { return slides[1].offsetLeft - slides[0].offsetLeft; }
    function mark(i) {
      idx = i;
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function go(i) {
      i = (i + n) % n;
      moving = Date.now() + 1200;
      track.scrollTo({ left: step() * i, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (!userPaused && !hold && !document.hidden) timer = setInterval(function () { go(idx + 1); }, (Number(root.dataset.seconds) || 2) * 1000);
    }
    function syncPause() {
      root.classList.toggle('is-paused', userPaused);
      pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.dataset.playLabel : pauseBtn.dataset.pauseLabel);
    }

    root.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () { go(idx + Number(b.dataset.dir)); play(); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(Number(d.dataset.dot)); play(); });
    });
    pauseBtn.addEventListener('click', function () { userPaused = !userPaused; syncPause(); play(); });

    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (Date.now() < moving) return;
        var s = step();
        if (s) mark(Math.round(track.scrollLeft / s));
      }, 120);
    });

    root.addEventListener('mouseenter', function () { hold = true; stop(); });
    root.addEventListener('mouseleave', function () { hold = false; play(); });
    root.addEventListener('focusin', function () { hold = true; stop(); });
    root.addEventListener('focusout', function () { hold = false; play(); });
    root.addEventListener('touchstart', function () { hold = true; stop(); }, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(function () { hold = false; play(); }, 8000); }, { passive: true });
    document.addEventListener('visibilitychange', play);

    mark(0);
    syncPause();
    play();
  });

  } catch(e) { console.error(e); }
})();
})();
